export const FONT_SIZE = "16px";
export const FONT_WEIGHT_REGULAR = 400;
export const FONT_WEIGHT_BOLD = 700;
export const FONT_COLOR_GENERAL = "rgba(0, 0, 0, 0.87)";
export const FONT_COLOR_DESCRIPTION = "#5c5c5c";
export const FONT_FAMILY = "Inter";

export const PADDING = "16px";
export const MARGIN = "16px";

export const TEXT_ALIGN = "left";

export const SPACER_SIZE = "8px";
